<div class="button-group-title" *ngIf="title">{{ title }}</div>
<div class="content">
	<ng-container *ngTemplateOutlet="content"></ng-container>
</div>
<dodo-cta-pointer
	*ngIf="showPointer && !hidePointer"
	[totalStops]="_totalStops"
	[pointAtStopeNumber]="_pointerPosition"
></dodo-cta-pointer>

<ng-template #content><ng-content></ng-content></ng-template>
